import * as React from "react"

import { cn } from "@/lib/utils"

export interface LabelProps extends React.ComponentProps<"label"> {
  size?: "default" | "field"
}

function Label({
  className,
  size = "default",
  ...props
}: LabelProps) {
  return (
    <label
      data-slot="label"
      className={cn(
        size === "field"
          ? "flex items-center gap-2 text-label text-ink-strong peer-disabled:cursor-not-allowed peer-disabled:opacity-50"
          : "flex items-center gap-2 text-sm font-medium leading-none text-ink-strong peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Label }
